import clsx from 'clsx';
import React from 'react';
import { CaptureClicksRichText } from '../RichText';
import { RelatedLinksProps } from './RelatedLinks.interface';
import useStyles from './RelatedLinks.styles';

const fitLinkAndArrow = ({ container, links }: any) => {
  if (!links || links.length < 0) return;

  const { width: widthContainer }: any = container.getBoundingClientRect() || {};
  links.forEach((link: any) => {
    const { width: widthLink }: any = link.getBoundingClientRect() || {};
    if (parseInt(widthLink, 10) > parseInt(widthContainer, 10) + 20) {
      link.classList.add('wrapSpace');
    }
  });
};

const RelatedLinks = ({ className: overrideClassName, content, theme }: RelatedLinksProps) => {
  const classes = useStyles({});
  const relatedLinksRef = React.useRef<any>(null);

  React.useEffect(() => {
    const relatedLinksEl = relatedLinksRef?.current;
    const links = Array.from(relatedLinksEl?.querySelectorAll('a') || []);

    if (relatedLinksEl && links && links.length > 0) {
      fitLinkAndArrow({ container: relatedLinksEl });
    }
  }, []);

  if (!content) return null;

  const rootClasses = clsx(classes.root, `${theme}-theme`);
  const relatedLinksClasses = clsx(
    classes.wrapper,
    classes.headline,
    classes.list,
    overrideClassName,
  );

  return (
    <div className={rootClasses} ref={relatedLinksRef} data-testid="qa-related-link-container">
      <CaptureClicksRichText
        customStyles
        content={content}
        theme={theme}
        className={relatedLinksClasses}
      />
    </div>
  );
};

export default RelatedLinks;
